import React from 'react';
import {
  Box,
  Typography,
  ButtonBase,
  Icon,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { Link } from 'react-router-dom';

import CertificateIcon from '../../../../components/icons/CertificateIcon';
import useStyles from './styles';

const Certificate = props => {
  const { courseId } = props;
  const classes = useStyles();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <ButtonBase
      className={classes.container}
      component={Link}
      to={`/course/${courseId}/certificate`}
    >
      <Box className="certificate-content">
        <CertificateIcon className="certificate-icon" />
        <Box className="certificate-text-container">
          <Typography
            className="certificate-text-title"
            variant="caption"
            noWrap={!isSmallScreen}
          >
            Visualizar certificado
          </Typography>
        </Box>
        <Icon className="certificate-infos-icon-go">chevron_right</Icon>
      </Box>
    </ButtonBase>
  );
};

export default Certificate;
